import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DatePicker } from '@/components/ui/date-picker';

interface DispatchDateRangeFilterProps {
  from: string;
  to: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
  onClear: () => void;
}

export const DispatchDateRangeFilter = ({
  from,
  to,
  onFromChange,
  onToChange,
  onClear,
}: DispatchDateRangeFilterProps) => {
  const { t } = useTranslation('operations');
  const hasValue = !!from || !!to;
  const fromId = useId();
  const toId = useId();

  return (
    <div className="flex flex-wrap items-end gap-2 rounded-md border border-efs-border bg-efs-bg-panel p-3">
      <div className="min-w-40 space-y-1">
        <label htmlFor={fromId} className="text-xs text-efs-text-muted">
          {t('efs.operations.dispatch.filters.requested_date_from', {
            defaultValue: '希望日（開始）',
          })}
        </label>
        <DatePicker
          id={fromId}
          value={from}
          onChange={onFromChange}
          maxDate={to || undefined}
          placeholder={t('efs.operations.dispatch.filters.date_not_set', {
            defaultValue: '未指定',
          })}
          className="h-8 text-xs"
        />
      </div>
      <div className="min-w-40 space-y-1">
        <label htmlFor={toId} className="text-xs text-efs-text-muted">
          {t('efs.operations.dispatch.filters.requested_date_to', {
            defaultValue: '希望日（終了）',
          })}
        </label>
        <DatePicker
          id={toId}
          value={to}
          onChange={onToChange}
          minDate={from || undefined}
          placeholder={t('efs.operations.dispatch.filters.date_not_set', {
            defaultValue: '未指定',
          })}
          className="h-8 text-xs"
        />
      </div>
      <Button type="button" size="sm" variant="outline" disabled={!hasValue} onClick={onClear}>
        <X className="mr-1 h-3 w-3" />
        {t('efs.operations.dispatch.filters.clear_dates', { defaultValue: '日付をクリア' })}
      </Button>
      <p className="text-xs text-efs-text-muted">
        {t('efs.operations.dispatch.filters.requested_date_help', {
          defaultValue: '開始・終了日はどちらか一方だけでも検索できます。',
        })}
      </p>
    </div>
  );
};
